<template>
  <div class="quiz-options">
    <div class="quiz-options-wrapper">
      <div v-if="isMultiselect" class="quiz-step-hint">
        {{ $t("common.youCanChooseSeveral") }}
      </div>

      <div class="quiz-options-items">
        <quiz-option
          v-for="(option, optionIndex) in options"
          :key="
            typeof option.value === 'string' || typeof option.value === 'number'
              ? option.value
              : option.translationKey || option.label || optionIndex
          "
          :selected="
            isMultiselect
              ? selectedOptions.includes(option.value)
              : value === option.value
          "
          :icon="option.icon"
          :label="
            option.translationKey ? $t(option.translationKey) : option.label
          "
          @click.native="selectOption(option.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuizOption from "@/components/dashboard/quiz/quiz_option.vue";

export default {
  name: "QuizOptions",

  components: {
    QuizOption,
  },

  props: {
    value: {
      type: [String, Array, Object],
      default: null,
      required: true,
    },

    isMultiselect: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every((option) => {
          return (
            (option.label || option.translationKey) &&
            option.value !== undefined
          );
        });
      },
    },
  },

  data() {
    return {
      selectedOptions: [],
    };
  },

  created() {
    this.selectedOptions = Array.isArray(this.value)
      ? this.value
      : this.value
      ? [this.value]
      : [];
  },

  methods: {
    selectOption(value) {
      if (this.isMultiselect) {
        const index = this.selectedOptions.indexOf(value);

        if (index > -1) {
          this.selectedOptions.splice(index, 1);
        } else {
          this.selectedOptions.push(value);
        }

        this.$emit("input", this.selectedOptions);

        return;
      }

      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-options {
  display: flex;
  justify-content: center;

  .quiz-options-wrapper {
    width: 696px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
  }

  .quiz-options-items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
  }

  .quiz-step-hint {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: bottom;
    color: #adb5bd;
  }

  .quiz-option {
    width: 100%;
  }
}
</style>
